import { render, staticRenderFns } from "./FullscreenToggler.vue?vue&type=template&id=48ecab31&scoped=true&lang=html&"
import script from "./FullscreenToggler.vue?vue&type=script&lang=js&"
export * from "./FullscreenToggler.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenToggler.vue?vue&type=style&index=0&id=48ecab31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ecab31",
  null
  
)

export default component.exports